import React, { useState, useEffect } from "react";
import { Card, Button, Icon } from "tabler-react";
import Tooltip from "react-simple-tooltip";
import TiktokIcon from "../../../assets/icon/tiktok.svg";

//hooks
import useShopPending from "../../../hooks/api/TiktokGOMOShop/useShopPending";
import useUsers from "../../../hooks/api/Users/useUsers";

const MainMenuSide = () => {
  const { pendingCount } = useShopPending();
  const { user, loginSession } = useUsers();
  useEffect(() => {
    if (loginSession.length == 0) {
      window.location.replace("/");
    }
  }, []);

  const [accessLevel, setAccessLevel] = useState("none");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setAccessLevel(
      user.length != 0
        ? user.apps_list.find((user) => user.app === "tiktok-shop").access
        : ""
    );
  }, [user]);

  useEffect(() => {
    if (user.length != 0 && accessLevel === "none") {
      window.location.replace("/");
    }
  }, [user, accessLevel]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  // console.log(user);

  return (
    <div className="main-menu-container">
      <Card>
        <Card.Header>
          <img src={TiktokIcon} />
        </Card.Header>
        <Card.Body>
          <Tooltip
            content="Home"
            radius={5}
            padding={5}
            placement="right"
            style={{ whiteSpace: "nowrap", width: "100%" }}
            zIndex={2}
          >
            <Button
              className="menu-button"
              color="cyan"
              onClick={() => window.location.replace("/")}
            >
              <Icon prefix="fa" name="home" />
            </Button>
          </Tooltip>

          <hr />
          {["admin", "edit"].includes(accessLevel) ? (
            <Tooltip
              content={`${pendingCount} Pending/s`}
              radius={5}
              padding={5}
              placement="right"
              style={{ whiteSpace: "nowrap", width: "100%" }}
              zIndex={2}
            >
              <Button
                className="menu-button"
                color="orange"
                onClick={() =>
                  window.location.replace("/TiktokGOMOShop/PendingDashboard")
                }
              >
                <Icon prefix="fa" name="warning" />
              </Button>
              <span className="badge">{pendingCount}</span>
            </Tooltip>
          ) : (
            ""
          )}

          <Tooltip
            content="Report"
            radius={5}
            padding={5}
            placement="right"
            style={{ whiteSpace: "nowrap", width: "100%" }}
            zIndex={2}
          >
            <Button
              className="menu-button"
              color="teal"
              onClick={() =>
                window.location.replace("/TiktokGOMOShop/Report/SummaryReport")
              }
            >
              <Icon prefix="fa" name="print" />
            </Button>
          </Tooltip>

          <Tooltip
            content="DR Dashboard"
            radius={5}
            padding={5}
            placement="right"
            style={{ whiteSpace: "nowrap", width: "100%" }}
            zIndex={2}
          >
            <Button
              className="menu-button"
              color="teal"
              onClick={() => window.location.replace("/TiktokGOMOShop/Dashboard")}
            >
              <Icon prefix="fa" name="dashboard" />
            </Button>
          </Tooltip>

          <Tooltip
            content="RTS Dashboard"
            radius={5}
            padding={5}
            placement="right"
            style={{ whiteSpace: "nowrap", width: "100%" }}
            zIndex={2}
          >
            <Button
              className="menu-button"
              color="teal"
              onClick={() =>
                window.location.replace("/TiktokGOMOShop/RTSDashboard")
              }
            >
              RTS
            </Button>
          </Tooltip>

          <Tooltip
            content="SI Dashboard"
            radius={5}
            padding={5}
            placement="right"
            style={{ whiteSpace: "nowrap", width: "100%" }}
            zIndex={2}
          >
            <Button
              className="menu-button"
              color="teal"
              onClick={() => window.location.replace("/TiktokGOMOShop/SIDashboard")}
            >
              <Icon prefix="fa" name="list" />
            </Button>
          </Tooltip>

          <Tooltip
            content="Orders"
            radius={5}
            padding={5}
            placement="right"
            style={{ whiteSpace: "nowrap", width: "100%" }}
            zIndex={2}
          >
            <Button
              className="menu-button"
              color="teal"
              onClick={() =>
                window.location.replace(
                  "/TiktokGOMOShop/Orders?dr_number=&SI_number=--&month="
                )
              }
            >
              <Icon prefix="fa" name="shopping-cart" />
            </Button>
          </Tooltip>

          <Tooltip
            content="Payment Release"
            radius={5}
            padding={5}
            placement="right"
            style={{ whiteSpace: "nowrap", width: "100%" }}
            zIndex={2}
          >
            <Button
              className="menu-button"
              color="teal"
              onClick={() =>
                window.location.replace("/TiktokGOMOShop/PaymentRelease")
              }
            >
              <Icon prefix="fa" name="money" />
            </Button>
          </Tooltip>

          <Tooltip
            content="Help"
            radius={5}
            padding={5}
            placement="right"
            style={{ whiteSpace: "nowrap", width: "100%" }}
            zIndex={2}
          >
            <a href="/TiktokGOMOShop/Help" target="_blank">
              <Button className="menu-button" color="teal">
                <Icon prefix="fa" name="question" />
              </Button>
            </a>
          </Tooltip>
        </Card.Body>
      </Card>
    </div>
  );
};

export default MainMenuSide;
